import _ from 'underscore';

import {RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';

import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';

export default function sortRequestTaskSchemas<T extends RequestTaskSchemaGraphQL | RequestTaskSchema>(
  requestTaskSchemas: Array<T>
): Array<T> {
  return _.sortBy(requestTaskSchemas, (schema) => schema.name.toLocaleLowerCase());
}
